<template>
  <div class="inviteUser">

    <!-- [Select language] start -->
    <!-- [Select language] end -->

    <!-- [ Wrapper content ] start -->
    <div class="wrapper">
      <SelectLanguage/>

      <!-- [ Header form ] start -->
      <Header icon="check-square"/>
      <!-- [ Header form ] end -->

      <!-- [ Title form ] start -->
      <Title title="Invite User"/>
      <!-- [ Title form ] end -->

      <!-- <keep-alive>
        <component :is="currentTabComponent" @tab="tab"></component>
      </keep-alive> -->

      <Form @tab="tab" :showForm="showForm"/>
      <FormRegistration :showFormRegistration="showFormRegistration"/>
    </div>
    <!-- [ Wrapper content ] end -->

  </div>
</template>

<script>
import SelectLanguage from '@/components/SelectLanguage.vue'
import Header from '@/components/auth/Header.vue'
import Title from '@/components/auth/Title.vue'
import Form from '@/components/users/Form.vue'
import FormRegistration from '@/components/users/FormRegistration.vue'
import axios from 'axios'
  export default {
    name: 'invite-user',
    components: {
      SelectLanguage,
      Header,
      Title,
      Form,
      FormRegistration
    },
    beforeCreate() {
      localStorage.clear();
    },
    data() {
      return {
        currentTabComponent: 'Form',
        showForm: true,
        showFormRegistration: false
      }
    },
    methods: {
      tab() {
        this.showForm = false,
        this.showFormRegistration = true
      }
    }
  }
</script>

<style lang="scss" scoped>
.inviteUser {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  text-align: center;
  padding: 0 20px;

  background: linear-gradient(0deg,#29b996,#3498db);
	background-size: 400% 400%;
	animation: backgroundGradient 10s ease infinite;

  text-rendering: optimizeLegibility;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	-webkit-tap-highlight-color: rgba(0,0,0,0);

  @keyframes backgroundGradient {
    0% {
      background-position: 0 0;
    }

    50% {
      background-position: 0 100%;
    }

    100% {
      background-position: 0 0;
    }
  }

  .wrapper {
    position:relative;
    box-sizing: border-box;
    max-width: 350px;
    padding: 40px 35px;
    background: #ffffff;
    box-shadow: 0 0 15px rgba(0,0,0,0.5);
  }
  .text-align-left {
    text-align: left;
  }
  .width-100 {
    width: 100%;
  }
  .mb {
  margin-bottom: 20px;
  }
}

.footer__link {
  line-height: 1.6;
  color: #909399;
}

.row-padding {
  padding: 10px 0;
}
</style>
